// Opciones del <select> «Usuario afectado» de la ficha del ticket (agente).
//
// El <select> es controlado por ticket.affectedUser.id. Si ese id no está entre
// las opciones (ticket antiguo cuyo afectado cambió o salió de la compañía, o la
// lista todavía cargando / falló), el navegador mostraría al PRIMER usuario de la
// lista como seleccionado y ese usuario no se podría elegir (no hay onChange).
// Por eso siempre se añade una opción deshabilitada para el valor actual.
import type { AffectedUser, TicketAffectedUser } from "./services/serviceDeskService";

export interface AffectedUserSelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export function affectedUserLabel(u: { name: string | null; email?: string | null }): string {
  const name = u.name || "Usuario sin nombre";
  return u.email ? `${name} (${u.email})` : name;
}

export function buildAffectedUserOptions(
  stored: TicketAffectedUser | null | undefined,
  companyUsers: AffectedUser[],
  loading: boolean,
): AffectedUserSelectOption[] {
  const users = Array.isArray(companyUsers) ? companyUsers : [];
  const options: AffectedUserSelectOption[] = users.map((u) => ({ value: u.id, label: affectedUserLabel(u) }));
  const storedId = stored?.id || "";

  if (!storedId) {
    return [
      { value: "", label: loading ? "Cargando usuarios…" : "Seleccionar usuario afectado…", disabled: true },
      ...options,
    ];
  }

  if (!users.some((u) => u.id === storedId)) {
    const label = affectedUserLabel({ name: stored?.name ?? null, email: stored?.email ?? null });
    return [
      {
        value: storedId,
        label: loading ? label : `${label} — no está en la compañía`,
        disabled: true,
      },
      ...options,
    ];
  }

  return options;
}
